var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'notes-badge': true,
  'notes-badge--has-badge': !!_vm.noteCount,
  'notes-badge--unread': !_vm.isNoteSeen
}},[_c('span',{staticClass:"notes-badge__text"},[_vm._v("Notes")]),(_vm.noteCount)?_c('span',{staticClass:"notes-badge__count"},[_vm._v(_vm._s(_vm.noteCount))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }